/* src/app/components/loader/loader.component.scss */
.loader-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.96);
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.loader-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.logo {
  width: 84px;
  animation: pulse 1.3s ease-in-out infinite;
}
.text {
  margin-top: 14px;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(0.9);
    opacity: 0.65;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
/*# sourceMappingURL=loader.component.css.map */
